import '../../monitoring/filters/numeric_filter_view.js.coffee'

Namespace('Profiling.Dashboard.Filters')

class Profiling.Dashboard.Filters.NumericFilterView extends Monitoring.Views.SocialContents.Filters.NumericFilterView
  _triggerQueryChanged: =>
    @searchQuery.triggerFilterChanged()
